import { useParams } from "react-router-dom";
import { useInscricaoDescontoBuscar } from "@/Services/Domain/Viagem/Inscricao/InscricaoDescontoService";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
import { Button, Divider, Flex } from "antd";
import InscricaoDescontoFormBasic, { IInscricaoDescontoFormBasicProps } from "./InscricaoDescontoFormBasic";
import { ReactElement } from "react";

export interface IInscricaoDescontoVisualizarScreenProps extends Omit<IInscricaoDescontoFormBasicProps, "onFinish"> {
    codigo?:number;
    buttoCencelar?: ReactElement;
    onCancelar?: (evento: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export default function InscricaoDescontoVisualizarScreen({
    codigo : codigoParam,
    buttoCencelar,
    onCancelar,
    ...rest
}:IInscricaoDescontoVisualizarScreenProps) {
    const { codigo : codigoRota } = useParams();
    const codigo = isNaN(Number.parseInt(codigoRota ?? "")) ? codigoParam : Number.parseInt(codigoRota ?? "");

    const {
        data,
        isLoading
    } = useInscricaoDescontoBuscar({
        codigo : codigo ?? 0,
        enabled : !isNaN(codigo as number) && (codigo as number) > 0
    });
    
    return <TelaCarregamento ativo={isLoading}>
        <InscricaoDescontoFormBasic
            {...rest}
            initialValues={{
                inscricaoDesconto : data ?? undefined
            }}
            codigo={codigo}
            disabled={true}
        />

        <Divider />

        <Flex gap="small" wrap="wrap" justify="center">
            {!!buttoCencelar && buttoCencelar}
            {!!!buttoCencelar && !!onCancelar && (
                <Button type="primary" danger htmlType="reset" onClick={onCancelar}>
                    Voltar
                </Button>
            )}
        </Flex>
    </TelaCarregamento>;
}